// Base Styles
import colors from "assets/mavric-theme/base/colors";
import borders from "assets/mavric-theme/base/borders";
import boxShadows from "assets/mavric-theme/base/boxShadows";

// Helper Function
import rgba from "assets/mavric-theme/functions/rgba";

const { black, primary } = colors;
const { borderWidth, borderRadius } = borders;
const { md } = boxShadows;

const card = {
  styleOverrides: {
    root: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      minWidth: 0,
      wordWrap: "break-word",
      backgroundColor: primary.main,
      backgroundClip: "border-box",
      border: `${borderWidth[0]} solid ${rgba(black.main, 0.125)}`,
      borderRadius: borderRadius.xl,
      boxShadow: md,
      overflow: "visible",
    },
  },
};

export default card;
